module.exports = __webpack_public_path__ + "static/media/testImage8.193463c1.png";